export const Base_Url = process.env.REACT_APP_BASE_URL;

export const Base_Url1 = process.env.REACT_APP_BASE_URL;

export const Url_For_View_Document = process.env.REACT_APP_VIEW_DOCUMENT_URL;

// Auth api urls 

export const registerapi = 'register'
export const loginapi = 'login'

// dashboard api urls
export const dashboard = 'dashboard'

// Warehouse Api urls
export const Addwarehouse = 'createwarehouse'
export const Warehouselist = 'warehouseslist'
export const deletewarehouse = 'deletewarehouse'
export const priceEstimator = 'priceEstimator'


// shipments api urls
export const addShipment = 'V1/B2C/shipment/add'
export const shipmentList = 'V1/B2C/shipment/list'
export const shipmentallList = 'V1/B2C/shipment/alllist'
export const createShippment = 'V1/B2C/shipment/create'
export const deleteShipment = "V1/B2C/shipment/cancel" 
export const updateShipment = 'V1/B2C/shipment/update'
// export const reverseShipment = 'reverseShipment'
// export const forwardorderlist = 'forwardorderlist'
export const shipmentlabel = 'V1/B2C/shipment/lable'
export const bulkshipmentlabel = "V1/B2C/shipment/BulkLable"
export const pickupRequest = 'pickupRequest'
export const track = 'V1/B2C/shipment/Track'
export const csvuplode = 'V1/B2C/shipment/UploadCsv'
export const labelCustomized = "V1/B2C/shipment/customize-label-view"

export const getpincode = 'getpincode'
export const uploadPincode = 'admin/updatePincodeList';

export const ndrList = 'ndrlist'

export const ndr = 'ndr'

export const Reattempt = "Reattempt"

export const Return = "Return"

export const pendingApi = "Pending";

export const ndrStatusList = "ndrStatusList"

export const uplodeDocument = "uplodeDocument"

export const userlist = "userlist";

export const userdocApprove = "userdocApprove"

export const userdata = "userdata"

export const walletRecharge = "wallet-recharge"

export const payment = "payment"

export const topUpList = "topUpList"

export const updateprofile = "updateprofile"

export const shippingCharges = "shippingCharges"

export const ratecsvuplode = "ratecsvuplode"

export const fetchUser = "fetchUser"

export const ratecardList = "ratecardList"

export const weightDispute = "weightDispute"

export const weightList = "admin/weightList"

export const weightDisputesAllforUser = "weightList";

export const weightListByStatus = "weightListStatus/Pending";

export const weightListStatusBylosed = "weightListStatus/close";

export const weightListStatusByAccept = "weightListStatus/Accept";

export const dispute_action = "dispute_action"

export const weightListStatusByRise = "weightListStatus/Rise";

export const dispute_action_admin = "admin/dispute_action";

export const forgetpassSendOtp = "forgetpassSendOtp";

export const verifyOtp = "forgetpassVerifyOtp";

export const updatePassword = "forgetpassChangePassword"

export const editwarehouse = "editwarehouse"

export const allwarehouseslist = "allwarehouseslist"

export const forwardorderlistall = 'forwardorderlistall'

export const accountUpdaterequest = "accountUpdaterequest";

export const accountUpdaterequestList = "accountUpdaterequestList"

export const userTrnxList = "admin/userTrnxList"

export const shippingUserCharges = "admin/shippingUserCharges"

export const notification = "notification"

export const readnotification = "readnotification"

export const grandTotalAmount = "totalAmount"

export const forwardBulkList = "forwardBulkList"

export const csvuplodeprocess = "csvuplodeprocess"


// integration api 

export const scanSopifyOrders = "/integration/shopify/orders"

export const scanSopifyOrdersList = "/integration/shopify/orderlist"
export const scanSopifyConnectionStatus = "/integration/shopify/checkconnectstatus"

export const scanSopifyauth = "/integration/shopify/auth"


export const woocomAuth="integration/woocommerce/auth"
export const woocomAuthCheck="integration/woocommerce/auth"


export const cancleOrder = "cancelOrder"

// public api for the priceEstimator and getPicode 

export const priceEstimatorPublic = "public/price-estimator"

export const getpincodePublic = "/public/getpincode"

export const resetuserpasswordapi = "admin/resetuserpassword"

export const addEmployee = "/admin/employee/add"

export const AllEmployeeList = "/admin/employeeList"

export const deleteEpmloyee = "admin/employee/delete"

export const editemployeeApi = "admin/employee/edit"

export const setPermissionApi = "/admin/permission"

export const updatewalletAmount = "/admin/updatewalletAmount"

export const deleteuser = "admin/deleteuser"

export const shopifyIntregration = "/integration/shopify/auth"

export const editShipment = "editShipment"

export const ndrAction = "ndrAction"

export const amountUpdate = "admin/amountUpdate"

export const remmitance = "COD/remittance"

 export const CodPlanChange = "COD/codPlanChange"

export const userCodList = "admin/COD/userCodList"

export const settlecod = "COD/settlecod"

export const paymentProcess = "admin/COD/PaymentProcess"

// whatapp intgration 

// offer api  

export const setOffer = "admin/offers/create"
export const fetchOffers="/offers/list"
export const updateOffer =  "admin/offers/update"
export const deleteOffer   = "admin/offers/delete"

export const getWhatappMessages="integration/whatshapp/whatsapppermission/show"
export const saveWhatappMessages="integration/whatshapp/whatsapppermission/save"

// label 

export const lableView  = "/V1/B2C/shipment/customize-label-view"
export const label  = "/V1/B2C/shipment/customize-label"

// B2B APi 

// dashboard api                                                                                                    
export const b2bdashboard = "B2B/dashboard"




// pincode api 

export const getB2bpIncode = "B2B/getpincode"

// warehouse Api Url 
export const b2bCreateWarehouse = "B2B/warehouse/create"
export const b2bWarehouseList = "B2B/warehouse/list"
export const b2bWarehouseListAll = "B2B/warehouse/listAll"
// Shipment Api  Url 

export const b2bAddShipment = "B2B/shipment/add"
export const b2bDeleteShipment = "B2B/shipment/cancle"
export const b2bAllShipmentList = "B2B/shipment/list"
export const b2bAllShipmentListAll = "B2B/shipment/listAll"
export const b2bCreateShipment = "B2B/shipment/create"
// export const b2bCreateShipment = "B2B/shipment/createtest"
export const b2bPriceEstimator = "B2B/price/estimator"
export const b2bTrackShipment = "B2B/shipment/track"
export const createpickuprequest  = "B2B/shipment/PickupRequest/create"
export const pickrequestList="/B2B/shipment/PickupRequest/list"
export const AppointmentBooking="B2B/shipment/AppointmentBooking"
export const updateB2b = "B2B/shipment/update"

//label

export const b2bLabel = "B2B/shipment/label"
export const b2bewaybill = "B2B/shipment/ewaybill"  

// rate apis                                     
export const b2bRateCard = "B2B/user/ratecard"; 
export const b2bsetprice =  "admin/B2B/user/pricing/setPricing";
export const getRetailerPrice = "admin/B2B/user/pricing/getRetailerPrice";
export const UploadCsv = "admin/B2B/user/pricing/uploadCsv"